import {
  AddOnFilterModel,
  useAddOnFilter,
  useCurrentWorkspace
} from '@gripp/shared-logic';
import { AddOnSearchInput, FilterType } from '@gripp/shared-ui';
import { useMemo } from 'react';
import { StyleSheet, View } from 'react-native';
import { FilterBar } from '../../shared/components/filter/filterBar';
import { AddOnsList } from './addOnsList';

export const AddOns = () => {
  const { data: addOnFilter } = useAddOnFilter();

  const impersonatingWorkspace = useCurrentWorkspace(true);
  const currentWorkspace = useCurrentWorkspace();

  const showCheckboxColumn = useMemo(
    () => !!impersonatingWorkspace,
    [impersonatingWorkspace]
  );

  const filter = useMemo(() => {
    const filter: AddOnFilterModel = addOnFilter ?? new AddOnFilterModel();
    filter.workspaceId = currentWorkspace?.id;
    return filter.getGraphQLFilter();
  }, [addOnFilter, currentWorkspace?.id]);

  return (
    <View style={styles.container}>
      <View style={styles.filtersContainer}>
        <View style={styles.searchContainer}>
          <AddOnSearchInput />
        </View>
        <FilterBar filterButtonTypes={[FilterType.ADDONCOLUMNS]} />
      </View>
      <AddOnsList filter={filter} showCheckboxColumn={showCheckboxColumn} />
    </View>
  );
};

const styles = StyleSheet.create({
  container: {
    flex: 1,
    flexDirection: 'column',
  },
  filtersContainer: {
    flexDirection: 'row',
    justifyContent: 'flex-start',
    alignItems: 'center',
    height: 44,
    marginBottom: 20,
  },
  searchContainer: {
    width: 390,
    marginRight: 20,
  },
});
